import React from "react";
import starIcon from "../../assets/images/star-icon.png";
import client1 from "../../assets/images/testimonials/client1.jpg";
import client2 from "../../assets/images/testimonials/client2.jpg";
import client3 from "../../assets/images/testimonials/client3.jpg";
import shape from "../../assets/images/shape/shape1.svg";
import Loadable from "@loadable/component";
import { useTranslation } from "gatsby-plugin-react-i18next";
const OwlCarousel = Loadable(() => import("react-owl-carousel3"));

const options = {
	loop: true,
	nav: true,
	dots: false,
	autoplayHoverPause: true,
	autoplay: true,
	margin: 30,
	navText: [
		"<i class='flaticon-left-SolutionTalentAcquisition'></i>",
		"<i class='flaticon-right-SolutionTalentAcquisition'></i>",
	],
	responsive: {
		0: {
			items: 1,
		},
		768: {
			items: 2,
		},
		992: {
			items: 2,
		},
	},
};

const PBd = () => {
	const { t } = useTranslation();

	const [display, setDisplay] = React.useState(false);

	React.useEffect(() => {
		setDisplay(true);
	}, []);

	return (
		<div className="testimonials-area bg-color pt-100 bg-fafafb">
			<div className="container">
				<div className="section-title">
					<span className="sub-title">
						<img src={starIcon} alt="testimonial" />
						Témoignages
					</span>
					<h2>{t("home.PBdh2")}</h2>
					<p>{t("home.PBdp1")}</p>
				</div>

				{display ? (
					<OwlCarousel
						className="testimonials-slides owl-carousel owl-theme"
						{...options}
					>
						<div className="single-testimonials-item">
							<p>{t("home.PBdp2")}</p>

							<div className="client-info">
								<div className="d-flex justify-content-center align-items-center">
									<img src={client1} alt="testimonial" />
									<div className="title">
										<h3>Profil "ANONYME"</h3>
										<span>
											Fonction: HR - Role: Talent - Level:
											Manager
										</span>
									</div>
								</div>
							</div>
						</div>

						<div className="single-testimonials-item">
							<p>{t("home.PBdp3")}</p>

							<div className="client-info">
								<div className="d-flex justify-content-center align-items-center">
									<img src={client2} alt="testimonial" />
									<div className="title">
										<h3>Profil "ANONYME"</h3>
										<span>
											Fonction: Supply Chain - Role:
											Planning - Level: Senior Manager
										</span>
									</div>
								</div>
							</div>
						</div>

						<div className="single-testimonials-item">
							<p>{t("home.PBdp4")}</p>
							<div className="client-info">
								<div className="d-flex justify-content-center align-items-center">
									<img src={client3} alt="testimonial" />
									<div className="title">
										<h3>Profil "PUBLIC"</h3>
										<span>Yannick Molinier</span>
									</div>
								</div>
							</div>
						</div>
					</OwlCarousel>
				) : (
					""
				)}

				{/*
                <div className="testimonials-view-btn text-center">
                    <Link to="/testimonials" className="default-btn">
                        <i className="flaticon-view"></i> 
                        Check Out All Reviews <span></span>
                    </Link>
                </div>
                */}
			</div>

			<div className="shape-img1">
				<img src={shape} alt="testimonial" />
			</div>
		</div>
	);
};

export default PBd;
